import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get("session_id");
    const magicToken = params.get("magic_token");

    if (!sessionId && !magicToken) {
      navigate("/$$login");
      return;
    }

    const exchange = async () => {
      try {
        let res;
        if (sessionId) {
          res = await api.post("/auth/session", { session_id: sessionId });
        } else {
          res = await api.post("/auth/magic-exchange", { token: magicToken });
        }
        // Save session token everywhere for reliability
        const token = res.data?.session_token;
        if (token) {
          localStorage.setItem("px_session_token", token);
          sessionStorage.setItem("px_session", token);
          // Also set a cookie manually as backup
          document.cookie = `px_token=${token};path=/;max-age=${30*24*60*60};SameSite=Lax`;
        }
        // Clean URL hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/crm", { state: { user: res.data }, replace: true });
      } catch (err) {
        let detail = err.response?.data?.detail;
        // Network/CORS error - no response object
        if (!err.response) {
          detail = "Connessione al server fallita. Riprova fra qualche secondo.";
        } else if (!detail) {
          detail = "Errore di autenticazione";
        }
        // If the session_id was consumed (Emergent returns user_data_not_found), guide the user
        if (typeof detail === "string" && detail.toLowerCase().includes("invalid session")) {
          detail = "La sessione di login e scaduta o gia usata. Riavvia il login.";
        }
        console.error("Auth exchange failed:", detail, err.response?.status);
        setError(typeof detail === "string" ? detail : JSON.stringify(detail));
      }
    };
    exchange();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-6">
        <div className="bg-[#fafafa] rounded-2xl p-8 max-w-md w-full text-center">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
            <span className="text-red-500 text-xl font-bold">!</span>
          </div>
          <h2 className="text-xl font-bold text-[#0f292f] mb-3">Accesso Negato</h2>
          <p className="text-sm text-[#666] mb-4">{error}</p>
          <p className="text-xs text-gray-400 mb-6">Se il problema persiste, prova a rientrare.</p>
          <div className="flex gap-3 justify-center">
            <button onClick={() => { localStorage.removeItem("px_session_token"); sessionStorage.removeItem("px_session"); navigate("/$$login"); }} className="bg-[#1d1d1f] text-white font-medium px-6 py-3 rounded-lg hover:bg-black transition-all text-sm" data-testid="auth-error-back-btn">
              Riprova Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#20c997] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-[#666]">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
